import styled from "@emotion/styled";
import { MACBOOK_PRO_MAX_WIDTH, MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
import HeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
const STICKY_TOP_PX = `${HeaderConstants.BASIC_HEADER_HEIGHT + 24}px`;
export const StyledSolutionPageLayoutComponent = styled.div`
  .template-page-content {
    max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
    margin: auto;
    margin-top: 72px;
    padding: 0 32px;
    display: flex;

    .desktop-navigation-wrapper {
      min-width: 320px;
      padding-right: 92px;
      margin-bottom: 48px;

      .navigation-sticky-wrapper {
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: ${STICKY_TOP_PX};
      }
    }

    .page-main-content {
      width: 100%;
      flex-grow: 1;
    }
  }

  @media (max-width: ${MACBOOK_PRO_MAX_WIDTH}) {
    .template-page-content {
      .desktop-navigation-wrapper {
        min-width: 260px;
        padding-right: 16px;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .template-page-content {
      max-width: 100vw;
      padding: 0 16px;
      margin-top: 8px;

      .desktop-navigation-wrapper {
        display: none;
      }
    }
  }
`;
